import { SubjectItem } from '../routes/ops/components/types/types';

export const findSubjectAbbreviation = (
  subjectCode: string,
  subjects: SubjectItem[]
): string => subjects.find((s) => s.code === subjectCode)!!?.abbreviation;
